/**
 * @TODO
 * it should support multiple/groping.
 */

import { useEffect, useState } from 'react'

export const RadioAccordion = ({
    content,
    label,
    conditionToshow,
    onClick,
    name,
    id,
    value,
    hidden = false,
}) => {
    const [checked, setChecked] = useState(false)

    useEffect(() => {
        setChecked(conditionToshow)
    }, [conditionToshow])

    return (
        <div data-input-name={name} className={`${hidden && 'hidden'}`}>
            <label
                className={`block cursor-pointer rounded-[14px] border bg-white px-4 py-[15px] transition-[border-color,box-shadow] duration-150 ${
                    conditionToshow
                        ? 'border-[#F28230] shadow-[0_0_0_3px_rgba(242,130,48,0.12)]'
                        : 'border-[#E1DACE]'
                }`}>
                <input
                    id={id}
                    onChange={onClick}
                    name={name}
                    type="radio"
                    checked={checked}
                    value={value}
                    className="sr-only"
                />
                <div className="flex items-center gap-[11px] text-[14.5px] font-semibold text-[#1A1D23]">
                    <span
                        className={`flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ${
                            conditionToshow
                                ? 'border-[#F28230]'
                                : 'border-[#CFC7BA]'
                        }`}>
                        <span
                            className={`h-[10px] w-[10px] rounded-full transition-colors duration-150 ${
                                conditionToshow
                                    ? 'bg-[#F28230]'
                                    : 'bg-transparent'
                            }`}
                        />
                    </span>
                    <span>{label}</span>
                </div>
                {conditionToshow && <div className="pt-4">{content}</div>}
            </label>
        </div>
    )
}
